import tw from 'twin.macro';
import styled from 'styled-components';

export const Wrapper = tw.div`
  p-10
`;

export const SubHeading = tw.p`
  text-center mb-5 text-lg
`;

export const CarouselWrapper = tw.div`
  w-full relative mt-3
`;

export const NavigationButtons = tw.div`
  flex justify-between sm:justify-end mb-8
`;

export const NavButton = tw.button`
  uppercase font-semibold text-sm sm:text-base mx-3 last:mr-0
`;

export const SlideContainer = tw.div`
  flex flex-col
`;

export const Image = styled.img`
    ${tw`w-full h-96 object-cover`}
    max-height: 500px;
    @media (max-width: 768px) {
    ${tw`h-64`}
    }
    @media (max-width: 480px) {
    ${tw`h-48`}
}
`;

export const CategoryBadge = tw.div`
  absolute top-0 right-0 bg-black/70 text-white px-2 py-1 text-xs font-bold sm:text-sm
`;

export const SlideContent = tw.div`
  p-4 text-left
`;

export const SlideLink = tw.a`
  no-underline text-black hover:underline
`;

export const SlideTitle = tw.h3`
  text-lg sm:text-3xl 
`;

export const SlideDescription = tw.p`
  mt-2 text-sm sm:text-base
`;

export const SourceDate = tw.p`
  font-semibold mt-2 text-sm sm:text-base
`;

export const BreakSpan = tw.span`
  inline-block mx-1
`;

export const ViewAllButtonWrapper = tw.div`
  flex justify-center mt-5
`;
